/**
 * Created by Administrador on 9/21/2016.
 */
(function(){
    'use strict';

    var autoCompleteSegment = {
        templateUrl: 'app/components/autocomplete/segment/segment.html',
        controller: autoCompleteSegmentController,
        controllerAs: 'vm',
        bindings:{
            ngModel: '=',
            originId: '=',
            destinyId: "=",
            //origin: "=",
            //destiny: "=",
            type: "@",
            action: "=",
            target: "@",
            onUpdate: '&',
            placeholder: '@'
        }
    };

    angular
        .module('completeAir')
        .component('autoCompleteSegment', autoCompleteSegment);

    autoCompleteSegmentController.$inject = ['$element', 'stretchAssistantService', 'routeService', '$timeout','linkService'];

    function autoCompleteSegmentController($element, stretchAssistantService, routeService, $timeout,linkService){
        var vm = this;
        var stretchAssistants = [],
            responseStretchAssistants = [];

        var eleJQ = $element.find(".form-control");

        vm.$onInit = function(){
            if(vm.action === undefined){
                vm.state = false;
            }else{
                vm.state = vm.action;
            }
        }

        vm.$postLink = function(){
            eleJQ.autocomplete({
                minLength: 1,
                delay: 200,
                source: function(request, response){
                    var search = request.term;
                    if(search !== ""){
                        if(vm.type === "origin"){
                            stretchAssistantService.search(search)
                                .then(function(res){
                                    responseStretchAssistants = ignoredRepeat(res.data._embedded.stretchAssistants);
                                    stretchAssistants = dataAutoComplete(responseStretchAssistants, vm.type);
                                    response(stretchAssistants);
                                });
                        }else if(vm.type === "destiny"){
                            stretchAssistantService.searchDestiny(vm.originId, search)
                                .then(function(res){
                                    responseStretchAssistants = res.data._embedded.stretchAssistants;
                                    stretchAssistants = dataAutoComplete(responseStretchAssistants, vm.type);
                                    response(stretchAssistants);
                                });
                        }
                    }
                },
                select: function(event, ui){
                    var posValue = stretchAssistants.indexOf(ui.item.value),
                        objectStretchAssistant = responseStretchAssistants[posValue];
                    if(vm.type === "origin"){
                        $timeout(function(){
                            vm.originId = linkService.getLinkId(objectStretchAssistant._embedded.airports[0]._links.self.href);
                            vm.origin = objectStretchAssistant._embedded.airports[0].iata
                        },50)
                    }else if(vm.type === "destiny"){
                        $timeout(function(){
                            vm.destinyId =  linkService.getLinkId(objectStretchAssistant._embedded.airports[1]._links.self.href);
                            vm.destiny = objectStretchAssistant._embedded.airports[1].iata
                        },50)
                    }
                }
            });
        }

        vm.onChangeValue = function(){
            if(vm.type === "origin")
                vm.originId = "";
            if(vm.type === "destiny")
                vm.destinyId = "";

            vm.onUpdate();
        }

        function ignoredRepeat(stretchAssistants){
            var tmp = [];
            var equal = 0;
            angular.forEach(stretchAssistants,function(val){
                if(equal!==linkService.getLinkId(val._embedded.airports[0]._links.self.href)){
                    tmp.push(val);
                    equal = linkService.getLinkId(val._embedded.airports[0]._links.self.href);
                }
            });
            return tmp;
        }

        function dataAutoComplete(stretchAssistants, type){
            var res = [];
            angular.forEach(stretchAssistants, function(stretchAssistant){
                var dataName = (type == "origin") ? stretchAssistant._embedded.airports[0].iata : stretchAssistant._embedded.airports[1].iata;
                res.push(dataName)
            });
            return res;
        }
    }
})();
